import {AfterViewInit, Component, EventEmitter, Input, Output, SimpleChanges} from "@angular/core";
import {CoreComponent} from "../core-component/core.component";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn
} from "@angular/forms";
import {Router} from "@angular/router";
import {SignUpService} from "../../../rg/service/sign-up.service";
import {OtpData} from "./data/otp-data";
import {AppMessageService} from "../../service/app-message.service";

@Component({
  selector: 'otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent extends CoreComponent implements AfterViewInit {

  regexNum: RegExp = /^\d+$/;
  formGroup: FormGroup | undefined;
  hiddenUserText: string | undefined;
  backButtonText: string = '';

  countdown: number = 0;
  resendTimeout: any;
  readonly RESEND_INTERVAL = 60;
  logInFlowStatusMessage:string = '';

  ngOtpConfig: any = {
    length: 6,
    allowNumbersOnly: true,
    isPasswordInput: false,
    inputAttributes: {
      autocomplete: 'one-time-code', //  Enables OTP auto-fill
      inputmode: 'numeric'           //  Optimizes mobile keyboard
    }
  };

  @Input() isOtpParentConfirmation: boolean = false;
  @Input() isLoginOtpFlow: boolean = false;
  @Input() externalErrorMessage: string | undefined;
  @Input() requestOtpBusy: boolean = false;
  @Input() confirmOtpBusy: boolean = false;
  @Output() onConfirmOtp = new EventEmitter<OtpData>;
  @Output() onRequestOtp = new EventEmitter<OtpData>;
  @Output() routeBack: EventEmitter<string> = new EventEmitter<string>();

  otpRequestMessage: string | undefined;
  errorMessage: string | undefined;
  value: any
  otpFormControl?: FormControl;

  constructor(protected formBuilder: FormBuilder,
              protected router: Router,
              protected messageService: AppMessageService,
              protected signUpService: SignUpService,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.createFormGroup();
    this.refreshComponent();
    this.formGroup?.get('otp')?.valueChanges.subscribe(() => {
      if (this.errorMessage) {
        this.errorMessage = undefined;
      }
    });
  }

  handleOtpChange(event: any) {

  }

  override ngOnChanges(changes: SimpleChanges) {
    if (this.externalErrorMessage) {
      this.errorMessage = this.externalErrorMessage;
    }
  }

  createFormGroup() {
    this.formGroup = this.formBuilder.group({
      otp1: [''],
      otp2: [''],
      otp3: [''],
      otp4: [''],
      otp5: [''],
      otp6: [''],
      otp: [null, this.lengthValidator(6)]
    });

    this.otpFormControl = this.formGroup.get("otp") as FormControl;

  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.getAnonymousPhoneView();
    this.initialized = true;

  }

  ngAfterViewInit() {

    // teimout required for mobile devices
    setTimeout(() => {
      const field = document.getElementById('otp1');
      if (field) {
        field.focus();
      }
    }, 500);

  }

  getAnonymousPhoneView() {
    const anyUserText = this.signUpService.phoneNumber;
    if (!anyUserText) {
      return;
    }

    let preDigits = anyUserText.substring(0, 3);
    let postDigits: string

    if (anyUserText.includes('@')) {
      //it's an email, only show first character
      preDigits = anyUserText.substring(0, 1);
      postDigits = anyUserText.slice(-4);
      this.hiddenUserText = `${preDigits}********${postDigits}`;
      this.backButtonText = 'Zurück zur E-Mail-Eingabe';
      this.logInFlowStatusMessage = 'Wir haben dein Einmalpasswort an die folgende E-Mail-Adresse gesendet:'
    } else {
      //it's a phone number
      preDigits = anyUserText.substring(0, 3);
      postDigits = anyUserText.slice(-3);
      this.hiddenUserText = `********${postDigits}`;
      this.backButtonText = 'Zurück zur Telefonnummer-Eingabe';
      this.logInFlowStatusMessage = 'Wir haben dein Einmalpasswort an die folgende Nummer gesendet:';
    }


  }


  pasteOtpCode(otp: string, noFocus: boolean = false) {

    if (!this.formGroup) {
      return;
    }

    // Split the text into individual characters
    const digits = otp.split('');

    // Assign each digit to the respective form control
    this.formGroup.controls['otp1'].setValue(digits[0] || '');
    this.formGroup.controls['otp2'].setValue(digits[1] || '');
    this.formGroup.controls['otp3'].setValue(digits[2] || '');
    this.formGroup.controls['otp4'].setValue(digits[3] || '');
    this.formGroup.controls['otp5'].setValue(digits[4] || '');
    this.formGroup.controls['otp6'].setValue(digits[5] || '');

    // Automatically focus the next input field if applicable
    const nextIndex = digits.length < 6 ? digits.length + 1 : 6;

    if (!noFocus) {
      const fieldToFocus = document.getElementById(`otp${nextIndex}`);

      if (fieldToFocus) {
        fieldToFocus.focus();
      }

    }

    this.handleOtp();
  }


  onPaste(event: ClipboardEvent): void {

    if (!this.formGroup) {
      return;
    }

    // Prevent the default pasting event
    event.preventDefault();

    // Get the text content from the clipboard
    const text = event.clipboardData?.getData('text') || '';

    this.pasteOtpCode(text);

  }


  focus(event: KeyboardEvent, input: number) {
    const currentFieldName = `otp${input}`;
    const currentField = this.formGroup?.get(currentFieldName);

    if (event.key == "Backspace") {
      this.navigateToPreviousField(event, input);

    } else if (event.key == "Enter") {
      return;
    } else if (!/^\d$/.test(event.key)) {  //check first if it's a number
      //currentField?.setValue(null);
      return;
    } else {
      currentField?.setValue(event.key);
      this.navigateToNextField(event, input);
    }

    this.updateOtpValue();
  }

  navigateToPreviousField(event: KeyboardEvent, input: number) {
    if (input == 1) {
      return;
    }
    input--;
    const newFieldName = `otp${input}`;
    const fieldToFocus = document.getElementById(newFieldName);
    if (fieldToFocus) {
      fieldToFocus.focus();
    }

  }

  clearOtp() {
    this.formGroup?.patchValue({
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
      otp6: "",
    })
  }

  navigateToNextField(event: KeyboardEvent, input: number) {
    let ok = this.regexNum.test(event.key);
    if (ok && input) {
      input++;
      const newFieldName = `otp${input}`;

      const control = this.formGroup?.get(newFieldName) as FormControl;
      if (control && control.errors) {
        control.setErrors(null);
      }

      const fieldToFocus = document.getElementById(newFieldName);

      if (fieldToFocus) {
        fieldToFocus.focus();
      }
    } else if (!input) {
      //last field so do nothing
    } else {
      return;
    }
  }

  updateOtpValue() {
    const otp = this.getOtpFromInputs();
    if (this.formGroup && this.formGroup.get('otp')) {
      this.formGroup.get('otp')?.setValue(otp);
    }
  }

  getOtpFromInputs(): string | null {
    // collects values from the input fields by their IDs
    let otpValue = '';
    if (this.formGroup) {
      for (let i = 1; i < 7; i++) {
        const inputValue = this.formGroup.get(`otp${i}`)?.value;
        otpValue += inputValue ? inputValue : null;
      }
      return otpValue;
    }
    return null;
  }

  handleOtp() {


    if (this.formGroup) {
      const otpValue = this.formGroup.get('otp')?.value;

      if (otpValue && otpValue.length == 6) {

        if (this.isOtpParentConfirmation) {

          const otpData = new OtpData(
            '',
            otpValue,
            (message: string) => {
              this.errorMessage = message;
              this.clearOtp();
              this.busy = false;
            },
            (message: string) => {
              this.busy = false;
            });

          this.onConfirmOtp.emit(otpData);
        } else {
          this.handleConfirmOtp(otpValue);
        }
      }
    }
  }

  handleConfirmOtp(otp: string) {
    const anyUserText = this.signUpService.phoneNumber;

    this.busy = true;

    //verify registration-otp
    if (anyUserText) {
      const otpData = new OtpData(
        anyUserText,
        otp,
        (message: string) => {
          this.errorMessage = message;
          this.clearOtp();
          this.busy = false;
        },
        (message: string) => {
          this.busy = false;
        });
      this.onConfirmOtp.emit(otpData);
    }
  }

  showInvalidFields() {
    if (this.formGroup) {
      for (let control in this.formGroup.controls) {
        let formControl = this.formGroup.controls[control];
        formControl.setErrors({invalid: true})
      }
    }
  }

  handleRequestOtp() {

    if (this.requestOtpBusy || this.countdown > 0) {
      return;
    }

    this.requestOtpBusy = true;

    const anyUserText = this.signUpService.phoneNumber;
    const otpData = new OtpData(
      anyUserText as string,
      undefined,
      (message: string) => {
        this.errorMessage = message;
        this.requestOtpBusy = false;
      },
      (message: string) => {
        this.otpRequestMessage = message;
        this.requestOtpBusy = false;
      },
    );
    this.onRequestOtp.emit(otpData);
    this.startResendCountdown();
  }

  lengthValidator(digitsLength: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      const valueStr = value?.toString() || '';
      return valueStr.length == digitsLength ? null : {'minDigits': {value: control.value}};
    };
  }

  preventNonNumeric(event: KeyboardEvent) {
    // Allow control keys to be used (backspace, tab, escape, enter, and arrow keys)
    const allowedKeys = ['Backspace', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Delete'];
    if (allowedKeys.includes(event.key)) {
      return; // Allow these keys
    }

    // Use a regular expression to check if the pressed key is a number
    const regex = new RegExp('^[0-9]+$');

    // Check if the key pressed is a number, if not prevent the default action (prevent typing the character)
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  override ngOnDestroy() {
    if (this.resendTimeout) {
      clearInterval(this.resendTimeout);
    }
  }
  startResendCountdown(): void {
    this.countdown = this.RESEND_INTERVAL;

    this.resendTimeout = setInterval(() => {
      this.countdown--;

      if (this.countdown === 0 && this.resendTimeout) {
        clearInterval(this.resendTimeout);
      }
    }, 1000);
  }

  get countdownLabel(): string {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;

    const paddedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const paddedSeconds = seconds < 10 ? '0' + seconds : seconds;
    return `Bitte überprüfe deine Eingaben oder wähle "Erneut senden" in ${paddedMinutes}:${paddedSeconds}`;
  }

  navigateBack() {
    const routeType = this.backButtonText?.includes('Mail') ? 'email' : 'phone';
    this.routeBack.emit(routeType);
  }



}
